import '../css/background.css';
import '../css/contact.css';
import Navbar from '../components/Navbar.jsx';
import Footer from '../components/Footer.jsx';
import TextField from '@material-ui/core/TextField';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { useState } from 'react';
// import axios from 'axios';


function Contact(props) {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const theme = createMuiTheme({
        palette: {
            primary: {
                main: '#C1883E'
            }
        }
    });

    // function handleSubmit(e) {
    //     e.preventDefault();

    //     axios({
    //         method: 'post',
    //         url: '/contact.php',
    //         headers: { "content-type": "application/json" },
    //         data: {
    //             name: name,
    //             email: email,
    //             message: message
    //         }
    //     })
    //     .then((res) => {
    //         resetForm();
    //     })
    //     .catch((error) => {
    //         console.log("Test");
    //         console.log(error);
    //     });
    // }

    // function resetForm() {
    //     setName('');
    //     setEmail('');
    //     setMessage('');
    // }

    function onNameChange(e) {
        setName(e.target.value);
    }

    function onEmailChange(e) {
        setEmail(e.target.value);
    }

    function onMessageChange(e) {
        setMessage(e.target.value);
    }

    return (
        <div className="background-shapes">
            <div className="contact">
                <Navbar currentComponent={props.currentComponent} setCurrentComponent={props.setCurrentComponent} />
                <h1>Contact</h1>

                <ThemeProvider theme={theme}>
                    <form className='contact-form' action="https://formspree.io/f/xbjqdgwn" method="POST">
                        <div className="input">
                            <TextField required name="name" className="text-field" color="primary" id="standard-basic" label="Name" value={name} onChange={(e) => onNameChange(e)} />
                        </div>
                        <div className="input">
                            <TextField type="email" required name="email" className="text-field" id="standard-basic" label="Email" value={email} onChange={(e) => onEmailChange(e)} />
                        </div>
                        <div className="input">
                            <TextField className="text-area" name="message" InputProps={{style:{paddingTop: '30%'}}} id="standard-basic" multiline label="Message" value={message} onChange={(e) => onMessageChange(e)} />
                        </div>
                        <button type="submit">SUBMIT</button>
                    </form>
                </ThemeProvider>
            </div>

            <Footer />
        </div>
    );
}

export default Contact;